const t = {}

t.loading = 'Loading...'

t.brand = {}
t.brand.lg = 'Central control management system'
t.brand.mini = 'Akuya'

t.add = 'Add'
t.delete = 'Delete'
t.deleteBatch = 'Delete'
t.update = 'Edit'
t.query = 'Query'
t.export = 'Export'
t.handle = 'Action'
t.confirm = 'Confirm'
t.cancel = 'Cancel'
t.logout = 'Sign Out'
t.agree = 'Agree'
t.refuse = 'Refuse'
t.prohibit = 'Prohibit'
t.enable = 'Enable'
t.invalid = 'Invalid'

t.prompt = {}
t.prompt.title = 'Prompt'
t.prompt.info = 'Confirm to carry out [{handle}] operation?'
t.prompt.success = 'Succeeded'
t.prompt.failed = 'Failed'
t.prompt.deleteBatch = 'Please select delete item'
t.prompt.logout = 'Do you cancel your current account ?'

t.message = {}
t.message.logoutCancel = 'Abandoning logout users'

t.validate = {}
t.validate.required = 'Required field cannot be empty'
t.validate.fillEng = 'Please fill in Letter'
t.validate.contentLong = 'Too long in content'
t.validate.format = '{attr} format error'
t.validate.choose = 'Please choose'
t.validate.Pleaseinput = 'Please input'

t.upload = {}
t.upload.text = 'Drop files here, or <em>Click Upload</em>'
t.upload.tip = 'Only support {format} format files! '
t.upload.button = 'Click to upload'
t.upload.selectFile = 'Select File'
t.upload.exceed = 'Upload beyond limit'
t.upload.editCotentText = 'Please edit the content'

t.datePicker = {}
t.datePicker.range = 'To'
t.datePicker.start = 'Start Date'
t.datePicker.end = 'End Date'
t.timePicker = {}
t.timePicker.start = 'Start Time'
t.timePicker.end = 'End Time'

t.fullscreen = {}
t.fullscreen.prompt = 'Your browser does not support this operation'

t.updatePassword = {}
t.updatePassword.title = 'Change Password'
t.updatePassword.username = 'Account'
t.updatePassword.password = 'Original'
t.updatePassword.newPassword = 'New Password'
t.updatePassword.comfirmPassword = 'Confirm'
t.updatePassword.validate = {}
t.updatePassword.validate.comfirmPassword = 'Confirm password is not consistent with new password input'

t.theme = {}
t.theme.d2 = 'D2Admin Classic'
t.theme.violet = 'Violet'
t.theme.line = 'Line'
t.theme.star = 'Star'
t.theme.tomorrowNightBlue = 'Tomorrow Night Blue'
t.theme.list = {}
t.theme.list.button = 'Select'
t.theme.list.buttonActive = 'Activated'

t.layout = {}
t.layout.hello = 'Hello'
t.layout.logout = 'Logout'
t.layout.updatePassword = 'Change Password'
t.layout.tooltip = {}
t.layout.tooltip.fullscreen = 'Fullscreen'
t.layout.tooltip.fullscreenActive = 'Exit Fullscreen'
t.layout.tooltip.theme = 'Theme'
t.layout.tooltip.search = 'Search'
t.layout.search = {}
t.layout.search.placeholder = 'Search Pages'
t.layout.search.tip1 = 'Press'
t.layout.search.tip2 = 'open search panel, and press'
t.layout.search.tip3 = 'close it.'

t.layoutTab = {}
t.layoutTab.index = 'Home'
t.layoutTab.noName = 'No Name'

t.contentTabs = {}
t.contentTabs.closeCurrent = 'Close Current Tab'
t.contentTabs.closeOther = 'Close Other Tabs'
t.contentTabs.closeAll = 'Close All Tabs'

/* pages */
t.notFound = {}
t.notFound.desc = 'Sorry! <em>missing</em> on the page you visited...'
t.notFound.back = 'Previous Page'
t.notFound.home = 'Home'

t.login = {}
t.login.language = 'Language'
t.login.motto = 'Time is the most precious treasure of all wealth'
t.login.form = {}
t.login.form.placeholderUsername = 'username'
t.login.form.placeholderPassword = 'password'
t.login.form.placeholderCaptcha = 'Captcha'
t.login.form.textSubmitButton = 'Sign In'
t.login.form.textForget = 'Forget'
t.login.form.textSignUp = 'Sign up'
t.login.footer = {}
t.login.footer.buttonHelp = 'Help'
t.login.footer.buttonPrivacy = 'Privacy'
t.login.footer.buttonClause = 'Clause'
t.login.copyright = {}
t.login.copyright.p1 = 'Copyright'
t.login.copyright.p2 = '2018 D2 Projects Open Source Organizational'
t.login.copyright.p3 = '@FairyEver'
t.login.ruleMessage = {}
t.login.ruleMessage.username = 'User name must be entered'
t.login.ruleMessage.password = 'Password must be entered'
t.login.ruleMessage.captcha = 'Captcha must be entered'

/* home */
t.home = {}
t.home.daily = 'Daily Update',
t.home.sales = 'Sales',
t.home.numberOfOrder = 'Number of Order',
t.home.numberOfUser = 'Number of User',
t.home.newUser = 'New User',
t.home.assetsIncome = 'Assets Income',
t.home.totalSales = 'Total Sales',
t.home.last30DaySales = 'Last 30 Days Sales',
t.home.transactionManagement = 'Transaction Management',
t.home.toDeliver = 'To Deliver',
t.home.refund = 'Refund',
t.home.inventoryWarn = 'Inventory Warn'
t.home.inventoryWarnDefaultValue = 'Inventory Warn Default Value'
t.home.inventoryQueryTime = 'Inventory Query Time'
t.home.Advertisingmanagement = 'Advertising management'
t.home.preview = 'preview'
t.home.picturemanagement = 'Home carousel picture management'
t.home.tabmanagement = 'Home tab management'
t.home.ContentManagement = 'Home Content Management'
t.home.Homebroadcast = 'Home broadcast'

/*商品 */
t.product = {}
t.product.name = 'Product Name'
t.product._ = 'Product'
t.product._id = 'Product ID'
t.product.list = 'Product List'
t.product.describe = 'Product Description'
t.product.operation = 'Main Product Action'
t.product.detailPage = 'Product Information'
t.product.detailPageContent = 'Product Info'
t.product.detailPageEdited = 'Edited'
t.product.detailPageUnedited = 'Unedited'
t.product.skuType = 'Attribute Type'
t.product.addRow = 'Add a row'
t.product.info = 'Info'
t.product.notice = 'Notice'
t.product.manufacturer = 'Manufacturer'
t.product.supplier = 'Supplier'
t.product.selectionReasons = 'Selection Reasons'
t.product.item = {}
t.product.item._ = 'ProductItem'
t.product.item.list = 'ProductItem List'
t.product.item.keyword = 'Keyword'
t.product.item.activate = 'Activate'
t.product.item.id = 'Platform ID'
t.product.item.name = 'ProductItem Name'
t.product.item.describe = 'Describe'
t.product.item.barCode = 'barCode'
t.product.item.goodsCode = 'SKU'
t.product.item.stock = 'Stock'
t.product.item.price = 'Promotion Price'
t.product.item.agentPrice = 'Agent Price'
t.product.item.projectPrice = 'Project Price'
t.product.item.originalPrice = 'SRP Price'
t.product.item.operation = 'Sub Product Action'
t.product.item.off = 'Off'
t.product.item.on = 'On'
t.product.item.copy = 'Duplicate'
t.product.item.freightCalculate = 'Freight Calculate'
t.product.item.freightCalculateValue = 'Freight Calculate Value'
t.product.item.weight = 'Weight'
t.product.item.volume = 'Volume'
t.product.item.big = 'Big'
t.product.item.priceAndStock = 'Price & Stock'
t.product.item.pictureAndVideo = 'Picture & Video'
t.product.item.picture = 'Picture (1)'
t.product.item.detailPicture = 'Picture Details (6)'
t.product.item.video = 'Video (1)'
t.product.item.extendValue = 'Color Code'
t.product.item.colorPicker = 'Color Picker'
t.product.item.increment = 'Increment'
t.product.item.attribute = 'Attribute'
t.product.item.attributeValue = 'Attribute Value'
t.product.item.attributeName = 'Attribute Name'
t.product.item.inventoryWarnValue = 'Inventory Warn Value'
t.product.item.salesVolume = 'Sales volume'
t.product.item.shopLogo = 'Shop Logo'
t.product.item.commission = 'Commission'
t.product.item.withCommission = 'Commission'
t.product.item.commissionPercent = 'Commission = Price * '
t.product.Historicalsales = 'Historical sales'
t.product.Pricerange = 'Price range'
t.product.Inventoryinterval = 'Inventory interval'
t.product.Confirmscreening = 'Confirm screening'

/* 订单 */
t.order = {}
t.order.traceNo = 'Order ID'
t.order.id = t.order.traceNo
t.order.amount = 'Order Amount(฿)'
t.order.status = 'Order Status'
t.order.WP = 'Wait Pay'
t.order.WS = 'Wait Ship'
t.order.WR = 'Wait Receive'
t.order.FINISH = 'Finish'
t.order.CANCEL = 'Cancel'
t.order.REFUNDING = 'Refunding'
t.order.REFUNDED = 'Refunded'
t.order.userPhone = 'User Phone'
t.order.paymentMethod = 'Payment Method'
t.order.cashPay = 'Cash Pay'
t.order.onlinePay = 'Online Pay'
t.order.cod = 'COD'
t.order.shippingMethod = 'Shipping Method'
t.order.pickUp = 'Pick Up'
t.order.delivery = 'Delivery'
t.order.time = 'Order Time'
t.order.finishedTime = 'Finished Time'
t.order.payTime = 'Pay Time'
t.order.count = 'Count'
t.order.toPay = 'To Pay'
t.order.toShip = 'To Ship'
t.order.finishOrder = 'Finish Order'
t.order.invoice = 'Invoice'
t.order.cancelOrder = 'Cancel Order'
t.order.detail = 'Detail'
t.order.party = 'Party'
t.order.trackingNumber = 'Tracking Number'
t.order.flashStatus = 'Status'
t.order.expressNumber = 'Express Number'
t.order.expressTime = 'Time'
t.order.expressInfo = 'Info'
t.order.zto = 'ZTO'
t.order.companyName = 'Company Name'
t.order.companyCode = 'Company Code'
t.order.placeOrder = 'Place Order'
t.order.payment = 'Payment'
t.order.deliver = 'Deliver'
t.order.complete = 'Complete'
t.order.collector = 'Collector'
t.order.collectAmount = 'Collect Amount'
t.order.collectTime = 'Collect Time'
t.order.receivingInfo = 'Receiving Information'
t.order.phone = 'Phone'
t.order.address = 'Address'
t.order.zipCode = 'Zip Code'
t.order.invoice = 'Invoice'
t.order.electronic = 'Electronic'
t.order.paper = 'Paper'
t.order.refund = 'Refund'
t.order.refundId = 'Refund ID'
t.order.agree = 'Agree'
t.order.refuse = 'Refuse'
t.order.refundProduct = 'Refund Product'
t.order.refundType = 'Refund Type'
t.order.delivered = 'Delivered'
t.order.processMethod = 'Process Method'
t.order.refundReason = 'Refund Reason'
t.order.refundRemarks = 'Refund Remarks'
t.order.receivableAmount = 'Receivable Amount(฿)'
t.order.receivedAmount = 'Received Amount(฿)'
t.order.remark = 'Order remark'
t.order.refundState = 'Refund status: refund completed '
t.order.refundId = 'Refund ID'
t.order.refundType = 'Refund type'
t.order.refundMethod = 'Processing mode'
t.order.remarks = 'Refund reason'
t.order.refundReason = 'Refund instruction'
t.order.goodsStatus = 'Arrival'
t.order.refundTypeEXCHANGE = 'Exchange goods'
t.order.refundTypeLEAKAGE = 'Missing hair'
t.order.refundTypeREFUND = 'refund'
t.order.goodsStatusDELIVERED = 'YES'
t.order.goodsStatusUNDELIVERED = 'Not yet arrived'
t.order.refundMethodREFUND = 'refund'
t.order.refundMethodRETURN = 'Return goods'
t.order.refundMethodREFUNDANDRETURN = 'Return refund'
t.order.refundMethodREISSUED = 'Replacement'
t.order.refundReasonNOTCONFORM = 'Description discrepancy'
t.order.refundReasonWRONGDELIVERY = 'Wrong delivery'
t.order.refundReasonQUALITY = 'quality problem'
t.order.refundReasonOTHER = 'Other'
t.order.childOrderId = 'Order Id'
t.order.mechantName = 'Mechant Name'
t.order.productImage = 'Product Image'
t.order.code = 'code'
t.order.productName = 'Product Name'
t.order.productPrice = 'Product Price'
t.order.productTotal = 'Total'
t.order.productStatus = 'Status'
t.order.operation = 'Operation'
t.order.shipTime = 'Ship Time'
t.order.viewLogistics='View Logistics'
t.order.discountPrice = 'Discount Price'
t.order.freightPrice = 'Freight Price'
t.order.productPrice = 'Product Price'
t.order.subOrderDetail = 'Sub Order Detail'
t.order.coreOrderId = 'Order ID'
t.order.allDatail = 'Total Order Detail'
t.order.walletPaid = 'Amount of wallet received'
t.order.codPrice = 'COD Receivable'
t.order.codPaid = 'COD received'
t.order.onlinePaid = 'Online payment received'
t.order.rejectOrder = 'Reject'
t.order.reasonCode = 'Reason Code'
t.order.reasonMsg = 'Reason Message'

/* 统计 */
t.statistical = {}
t.statistical.type = 'Type'
t.statistical.date = 'Date'
t.statistical.amount = 'Amount(฿)'
t.statistical.orders = 'Orders'
t.statistical.dailyReport = 'Daily Report'
t.statistical.monthlyReport = 'Monthly Report'
t.statistical.annualReport = 'Annual Report'

/* 广告 */
t.advert = {}
t.advert.name = 'Advert Name'
t.advert.jumpType = 'Jump Type'
t.advert.noJump = 'No Jump'
t.advert.productItemDetail = 'ProductItem Detail'
t.advert.share = 'Share'
t.advert.classification = 'Classification'
t.advert.login = 'Login'
t.advert.wallet = 'Wallet'
t.advert.buyfree = 'BUYFREE'
t.advert.buyfreeDetail = 'BUYFREEDETAIL'
t.advert.activityId = 'Activity ID'
t.advert.productItemID = 'ProductItem ID'
t.advert.priority = 'Priority'
t.advert.periods = 'Periods'
t.advert.ONCEADAY = 'Once a day'
t.advert.EVERYTIME = 'Everytime'
t.advert.ONLYONCE = 'Once'
t.advert.effectiveDate = 'Effective Date'
t.advert.effective = 'Effective'
t.advert.activity = 'Activity'
t.advert.monopoly = 'Monopoly'
t.advert.merchant = 'Shop'
t.advert.brand = 'Brand'


/* 佣金 */
t.commission = {}
t.commission.userName = 'User Name'
t.commission.newUserName = 'New User Name'
t.commission.oldUserName = 'Old User Name'
t.commission.newUserCountry = 'New User Country'
t.commission.oldUserCountry = 'Old User Country'
t.commission.presentMoney = 'Present Money(฿)'
t.commission.status = 'Status'

t.menu = {}
t.menu.name = 'Name'
t.menu.icon = 'Icon'
t.menu.type = 'Type'
t.menu.type0 = 'Menu'
t.menu.type1 = 'Button'
t.menu.sort = 'Sort'
t.menu.url = 'Route'
t.menu.permissions = 'Auth ID'
t.menu.permissionsTips = 'Multiple separated by commas, such as: sys:menu:save,sys:menu:update'
t.menu.parentName = 'Superior'
t.menu.parentNameDefault = 'Top Menu'
t.menu.resource = 'Auth Resources'
t.menu.resourceUrl = 'Resource URL'
t.menu.resourceMethod = 'Request Method'
t.menu.resourceAddItem = 'Add an Item'
t.menu.label = {}
t.menu.label.closeLeft = 'Close Left'
t.menu.label.closeRight = 'Close Right'
t.menu.label.closeOther = 'Close Other'
t.menu.label.closeAll = 'Close All'


t.role = {}
t.role.name = 'Name'
t.role.remark = 'Remarks'
t.role.createDate = 'Create Date'
t.role.menuList = 'Menu Scope'
t.role.deptList = 'Data Scope'

/* user */
t.user = {}
t.user.username = 'User Name'
t.user.deptName = 'Department'
t.user.email = 'Email'
t.user.mobile = 'Mobile'
t.user.status = 'Status'
t.user.status0 = 'Disable'
t.user.status1 = 'Enable'
t.user.createDate = 'Create Date'
t.user.password = 'Password'
t.user.comfirmPassword = 'Confirm'
t.user.realName = 'Real Name'
t.user.gender = 'Gender'
t.user.gender0 = 'Male'
t.user.gender1 = 'Female'
t.user.gender2 = 'Secure'
t.user.roleIdList = 'Role Config'
t.user.validate = {}
t.user.validate.comfirmPassword = 'Confirm password is not consistent with password input'
t.user.country = 'Country'
t.user.name = 'Name'
t.user.level = 'Level'
t.user.balance = 'Balance'
t.user.level0 = 'Ordinary User'
t.user.level1 = 'Proxy User'
t.user.level2 = 'Project User'
t.user.usable = 'Usable'
t.user.cash = 'Cash'
t.user.present = 'Present'
t.user.freeze = 'Freeze'
t.user.point = 'Point'
t.user.logout = 'Logout'
t.user.loginPassword = 'Login Password'
t.user.revoke = 'Revoke'
t.user.grant = 'Grant'

/* 钱包 */
t.wallet = {}
t.wallet.amount = 'Amount(฿)'
t.wallet.auditAdmin = 'Audit Admin'
t.wallet.auditTime = 'Audit Time'
t.wallet.finishAdmin = 'Finish Admin'
t.wallet.inProgress = 'Pending review'
t.wallet.agree = 'Pending transfer'
t.wallet.refuse = 'Not Approved'
t.wallet.finish = 'Finish'
t.wallet.agreeButton = 'Agree'
t.wallet.refuseButton = 'Refuse'
t.wallet.transferButton = 'Transfer completed'
t.wallet.Remarks = 'Remarks'
t.wallet.configwithdraw ='Confirm consent to withdraw?'
t.wallet.configtransfer ='Whether to confirm the transfer?'
t.wallet.denialReason ='Denial Reason'
t.wallet.viewInfo ='View transfer information'
t.wallet.bankName ='Bank Name'
t.wallet.Account ='Account'
t.wallet.name ='Name'

/* 权限 */
t.power = {}
t.power.role = 'Role'
t.power.roleName = 'Role Name'
t.power.menu = 'Menu'

/* 系统 */
t.sys = {}
t.sys.apk = {}
t.sys.apk.title = 'Title'
t.sys.apk.content = 'Content'
t.sys.apk.versionName = 'Version Name'
t.sys.apk.versionCode = 'Version Code'
t.sys.apk.pkg = 'Pkg'
t.sys.apk.mandatoryUpdate = 'Mandatory Update'
t.sys.apk.file = 'File'
t.sys.apk.all="All"
t.sys.apk.cearch="search"
t.sys.apk.version="New version"
t.sys.apk.codeTip="Version name"
t.sys.apk.mandatoryUpdateTip="Whether to force updates-all"
t.sys.apk.client="Client-all"
t.sys.apk.yes='Yes'
t.sys.apk.no='No'
t.sys.apk.uploadTime='Update time'
t.sys.apk.kehutype='Client'
t.sys.apk.mandatoryUpdate='Whether to force updates'
t.sys.apk.status='status'
t.sys.apk.apkoperation='APK operations'
t.sys.apk.forceButton='Set to force update version'
t.sys.apk.forceNoButton='Set as non mandatory update version'
t.sys.apk.deleteButton='Delete version'
t.sys.apk.reuploadButton='re-upload'
t.sys.apk.modifyButton='Modify'
t.sys.apk.updateDescription='Update description'

t.sys.dict = {}
t.sys.dict.key = 'Key'
t.sys.dict.value = 'Value'
t.sys.dict.hint = 'Hint'
t.sys.dict.search = 'Key/Value/Hint'

t.sys.multilingual = {}
t.sys.multilingual.search = 'English/Thai'

t.sys.cache = {}
t.sys.cache.refreshAllCache = 'Refresh All Cache'
t.sys.cache.refreshActivityCache = 'Refresh Activity Cache'
t.sys.cache.refreshTagCache = 'Refresh Tag Cache'
t.sys.cache.refreshCarouselCache = 'Refresh Carousel Cache'
t.sys.cache.refreshCategoryCache = 'Refresh Category Cache'
t.sys.cache.refreshNewCategoryCache = 'Refresh New Category Cache'

t.sys.cache.refreshActivityCacheSuccess = 'Refresh activity cache success'
t.sys.cache.refreshTagCacheSuccess = 'Refresh tag cache success'
t.sys.cache.refreshCarouselCacheSuccess = 'Refresh cache successful'
t.sys.cache.h5refreshCarouselCache = 'Refresh H5 homepage cache'
t.sys.cache.refreshCategoryCacheSuccess = 'Refresh category cache success'
t.sys.cache.refreshNewCategoryCacheSuccess = 'Refresh new category cache success'

/**目录**/
t.catalog={}
t.catalog.CATEGORY = 'Category'
t.catalog.NEW_CATEGORY = 'Category'
t.catalog.ACTIVITY = 'Activity'
t.catalog.TAG = 'Tag'
t.catalog.modifySort = 'Modify Sort'
t.catalog.show = 'Show'


t.category = {}
t.category.label = {}
t.category.label.category = 'Category'
t.category.label.categoryName = 'Name'
t.category.label.append = 'Append'
t.category.label.relation = 'Relation'
t.category.label.unrelation = 'Unrelation'
t.category.label.update = 'Update'
t.category.label.delete = 'Delete'
t.category.label.sort = 'Sort'
t.category.label.advert = 'Advert'
t.category.label.cover = 'Cover'
t.category.label.nameLevel1 = 'Catalog:A-Level'
t.category.label.nameLevel2 = 'Catalog:B-Level'
t.category.label.nameLevel3 = 'Catalog:C-Level'
t.category.label.relationDetail = 'Relation Detail'
t.category.label.batchAddPrefix = 'Batch Operations: Selected '
t.category.label.skuProportion = 'Effective SKUs / Total'
t.category.label.off = 'Off'
t.category.label.on = 'On'


t.catalog.merchant = {}
t.catalog.merchant.itemAdded = 'Supplier Added'
t.catalog.merchant.canAddItems = 'Can Add Supplier'

/**图表**/
t.charts={}
t.charts.dailyUsers = 'Daily Users'
t.charts.hourlyUsers = 'Hourly Users'
t.charts.total = 'Total'
t.charts.shareCount = 'Share Count'
t.charts.shareRate = 'Share Rate'
t.charts.dailyOrders = 'Daily Orders'
t.charts.totalCount = 'Total Count'
t.charts.totalAmount = 'Total Amount'
t.charts.finishedCount = 'Finished Count'
t.charts.finishedTotalAmount = 'Finished Total Amount'
t.charts.finishedRate = 'Finished Rate'

/**折扣**/
t.discount={}
t.discount.activityId = 'Campaign ID'
t.discount.activityName = 'Campaign'
t.discount.activityProfile = 'Campaign Dispaly'
t.discount.activityTag = 'Activity Tag'
t.discount.activate = 'Activate'
t.discount.activateOn = 'On'
t.discount.activateOff = 'Off'
t.discount.durationTime = 'Duration Time'
t.discount.brand = 'Brand'
t.discount.brandName = 'Brand Name'
t.discount.brandProfile = 'Brand Profile'
t.discount.brandInitials  = 'Brand Initials'
t.discount.brandLogo = 'Brand Logo'
t.discount.startTime = 'Start Time'
t.discount.endTime = 'End Time'
t.discount.productItemPicture = 'ProductItem Picture'
t.discount.relationActivitys = 'Relation Activitys'
t.discount.assure = 'Brand Assure'
t.discount.address = 'Shipping Address'
t.discount.tips = 'Tips'
t.discount.deliveryTimeTips = 'Delivery Time Tips'
t.discount.paymentType = 'Payment Type Tips'
t.discount.deliveryTimePicture = 'Delivery Time Picture'
t.discount.paymentTypePicture = 'Payment Type Picture'
t.discount.allPriceAdjustment = 'All Price Adjustment'
t.discount.calculateType = 'Calculate Type'
t.discount.calculateValue = 'Discount Rate'
t.discount.timeSetting = 'Time Setting'
t.discount.deleteSetting = 'Delete'
t.discount.shopName = 'Shop name'
t.discount.productName = 'Product name/item name/ID'
t.discount.skuNum= 'SKU quantity'
t.discount.baseBigPic = 'Activities Big Image'
t.discount.Setrecord = 'Set record'
t.discount.Currentsetting = 'Current setting'
t.discount.texttopleft = 'Brand discount page display'
t.discount.texttopright = 'Products below discount'
t.discount.textconleft = 'Brand new product page display'
t.discount.day = 'day'
t.discount.textconright = 'Merchandise on shelves'
t.discount.textbotleft = 'Brand discount page display settings'
t.discount.inputtipone = 'Please enter the discount number'
t.discount.inputtiptwo = 'Please enter the number of days'
t.discount.tableone = 'Discount display value(%)'
t.discount.tabletwo = 'New product display days (days)'
t.discount.tabletime = 'Set time'
t.discount.tablepeopen = 'Operator'

/**会员**/
t.member={}
t.member.account = 'Member Account'
t.member.relatedCreateTime = 'Related Create Time'
t.member.status = 'Status'
t.member.yStatus = 'Binding'
t.member.nStatus = 'Abnormal'
t.member.lowerMemberAccount = 'Lower Member Account'
t.member.obtainAmount = 'Obtain Amount'
t.member.unbinding = 'Unbinding'
t.member.amount = 'Amount'
t.member.superiorMemberAccount = 'Superior Member Account'
t.member.superiorAmount = 'Superior Amount'
t.member.invitationCode = 'Invitation Code'
t.member.copyInvitationCodeSuccess = 'Copy Successful. The Currently Copied Invitation Code Is '
t.member.copyInvitationCodeFailed = 'Copy Failed'
t.member.rewardName = 'Reward Name'
t.member.rewardAmount = 'Amount'
t.member.rewardCreateTime = 'Time'
t.member.rewardStatus = 'Status'
t.member.rewardAmountAccount = 'Amount Account'
t.member.yRewardStatus = 'Normal'
t.member.nRewardStatus = 'Abnormal'
t.member.uRewardStatus = 'Unknown'
t.member.newComerAward = 'Newcomer Award'
t.member.pullNewAward = 'Pull New Award'
t.member.rewardRecord = 'Reward Record'
t.member.firstOrderAward = 'First Order Award'

/**拉新**/
t.pullnew={}
t.pullnew.currentSetting = 'Current Setting'
t.pullnew.unlimitedDuration = 'Unlimited Duration'
t.pullnew.newComerAwardAmount = 'NewComer Award Amount (New Users)'
t.pullnew.pullNewAwardAmount = 'Pull New Award Amount (Old Users)'
t.pullnew.bindNewComerCount = 'Bind NewComer Count'
t.pullnew.newComerAwardAmountCount = 'NewComer Award Count'
t.pullnew.pullNewAwardAmountCount = 'Pull New Award Count'
t.pullnew.totalAmountCount = 'Total'
t.pullnew.queryMore = 'Show Detail'
t.pullnew.statistics = 'Statistics'
t.pullnew.modifySettings = 'Modify Settings'
t.pullnew.modifySettingsNum = 'Times'
t.pullnew.allBindNewComerCount = 'Bind NewComer Count'
t.pullnew.showBeforeDetail = 'Show History'
t.pullnew.newcomerAmount = 'Newcomer Amount'
t.pullnew.pullNewAmount = 'Pull New Amount'
t.pullnew.totalAmount = 'Total Amount'
t.pullnew.bindingPullNewActivityEffective = 'Binding PullNew Activity Effective'
t.pullnew.bindingNewcomerActivityEffective = 'Binding Newcomer Activity Effective'
t.pullnew.remark = 'Remark'
t.pullnew.cancel = 'Cancel'
t.pullnew.confirmModify = 'Confirm'
t.pullnew.pastRecord = 'Past Record'
t.pullnew.time = 'time'

/**分享活动**/
t.member.share={}
t.member.share.tipSmallWordSetting = 'Tip Small Word Setting'
t.member.share.promptContentSetting = 'Prompt Content Setting'
t.member.share.contentSetting = 'Content Setting'
t.member.share.isShow = 'Whether to display'

/**buyfree管理**/
t.buyfree = {}
t.buyfree.add = 'Add Buyfree'
t.buyfree.productName = 'Product Name'
t.buyfree.itemId = 'Platform ID'
t.buyfree.itemPicture = 'Picture'
t.buyfree.itemName = 'ProductItem Name'
t.buyfree.code = 'Code'
t.buyfree.brandName = 'Brand Name'
t.buyfree.brandLogo = 'Brand Logo'
t.buyfree.rule = 'Rule'
t.buyfree.startTime = 'Start Time'
t.buyfree.endTime = 'End Time'
t.buyfree.numberOfParticipants='Number Of Participants'
t.buyfree.invitationsNumber='Invitations Number'
t.buyfree.stock = 'Stock'
t.buyfree.status = 'Status'
t.buyfree.inProgress = 'In Progress'
t.buyfree.closed = 'Closed'
t.buyfree.itemOff = 'Off'
t.buyfree.details = 'Details'
t.buyfree.activityTime = 'Activity Time'
t.buyfree.pullNewOnly = 'Pull New Only'
t.buyfree.pullNewNumber = 'Pull New Number'
t.buyfree.coExistWithPullNew = 'Co-Exist With PullNew'
t.buyfree.isNewPull = 'Is New Pull'
t.buyfree.isParallel = 'Is Parallel'
t.buyfree.ruleDescription = 'Rule Description'
t.buyfree.pageRuleDescription = 'Page Rule Description'
t.buyfree.activityOff = 'Activity Off'
t.buyfree.todayNewParticipantsNumber = 'Today New Participants Number'
t.buyfree.totalNumber = 'Total Number'
t.buyfree.totalPullNewNumber = 'Total Pull New Number'
t.buyfree.totalReward = 'Total Reward'
t.buyfree.rewardedUsers = 'Rewarded Users'
t.buyfree.surplusStock= 'Surplus Stock'
t.buyfree.userName = 'User Account'
t.buyfree.participateTime = 'Participate Time'
t.buyfree.completion = 'Completion'
t.buyfree.lastPullNewTime = 'Last Pull New Time'
t.buyfree.userAccount = 'User Account'
t.buyfree.activityPullNewDetails = 'Activity Pull New Details'
t.buyfree.binddingTime = 'Bindding Time'
t.buyfree.buyfreeType = 'Buyfree Type'
t.buyfree.buyfreeTypeForBuyfreeKey = 'Buyfree'
t.buyfree.buyfreeTypeForBuyfreeDraw = 'Shake'

/**
 * 摇一摇
 */
t.shake= {}
t.shake.add = 'Add Shake'
t.shake.shakeData = 'Data'
t.shake.shakeRule = 'Rule'
t.shake.next = 'Next'
t.shake.before = 'Before'
t.shake.activityData = 'Activity Data'
t.shake.activityName = 'Activity Name'
t.shake.logo = 'LOGO'
t.shake.coverLogo = 'Cover Logo'
t.shake.ruleDescription = 'Rule Description'
t.shake.defaultData = 'Default Data'
t.shake.backgroundPicture = 'Background Picture'
t.shake.shakePicture = 'Shake Picture'
t.shake.decorationPicture = 'Decoration Picture'
t.shake.shakeGIF = 'Shake GIF'
t.shake.notWinningText = 'Not Winning Text'
t.shake.winningText = 'Winning Text'
t.shake.notWinningPicture = 'Not Winning Picture'
t.shake.winningSmallPicture = 'Winning Small Picture'
t.shake.notWinningSmallPicture = 'Not Winning Small Picture'
t.shake.settingPrize = 'Setting Prize'
t.shake.prizeType = 'Prize Type'
t.shake.prizeName = 'Prize Name'
t.shake.prizeLevel = 'Prize Level'
t.shake.prizeCount = 'Prize Count'
t.shake.baseWinningRate = 'Base Winning Rate'
t.shake.setTimeWinningRate = 'Set Time Winning Rate'
t.shake.tips = 'Tips'
t.shake.remark = 'Remark'
t.shake.setTime = 'Set Time'
t.shake.addTimes = 'Add Times'
t.shake.lotteryNumber = 'Lottery Number'
t.shake.lotteryAllNumber = 'Lottery All Number'
t.shake.personEverydayLotteryNumber = 'Person Everyday Lottery Number'
t.shake.personAllLotteryNumber = 'Person All Lottery Number'
t.shake.inputCount = 'Input Count'
t.shake.productItem = 'Product Item'
t.shake.wallet = 'Wallet'
t.shake.amount = 'Amount'
t.shake.addPrize = 'Add Prize'
t.shake.addMoney = 'Add Money'
t.shake.sort = 'Sort'
t.shake.awardType = 'Award Type'
t.shake.awardTypeNORMAL = 'NORMAL'
t.shake.awardTypeSINGLE_MUTEX = 'SINGLE MUTEX'
t.shake.awardTypeMULT_MUTEX = 'MULT MUTEX'
t.shake.awardTypeALL_MUTEX_DAY = 'ALL MUTEX DAY'
t.shake.ruleName = 'Rule Name'
t.shake.havekey = 'Active Key'
t.shake.key = 'Key'
t.shake.closeAndReset = 'Close Will Empty Unsaved Data'
t.shake.chooseRule = 'Choose Rule'
t.shake.chooseRuleType1 = 'All Time'
t.shake.chooseRuleType2 = 'Custom Time'
t.shake.chooseRuleType3 = 'Day Time'
t.shake.chooseRuleType4 = 'Date Time'
t.shake.limitAwardTimes = 'Limit Award Times'
t.shake.ruleContent = 'Rule Content'
// t.shake.tips = 'Please pull right to see if the rules are completed!'


/** 轮播视频 */
t.video={}
t.video.name = 'Video Name'
t.video.video = 'Video'
t.video.createTime = 'Create Time'
t.video.remark = 'Remark'
t.video.sort = 'Sort'
t.video.status = 'Status'
t.video.itemOff = 'Unpublish'
t.video.itemOn = 'Publish'
t.video.delete = 'Delete'
t.video.Collapse = 'Collapse'
t.video.description = 'Description'
t.video.statusShow = 'Show'
t.video.statusHide = 'Hide'
t.video.upload = 'Video Upload'
t.video.uploadEx = 'Video upload failed, please re-upload'
t.video.noSupport = 'Your browser does not support video playback'
t.video.noUpload = 'Please upload a video'

/** 新首页 */

/** 标签 */
t.homepage = {}
t.homepage.carousel = 'HomePage Carousel'
t.homepage.tags = 'HomePage Tag'
t.homepage.activities = 'Activities'
t.homepage.jumpEditor = 'Jump Editor'
t.homepage.taglist = {}
t.homepage.taglist.id = 'Tag ID'
t.homepage.taglist.tagName = 'Tag Name'
t.homepage.taglist.icon = 'Icon'
t.homepage.taglist.createTime = 'Create Time'
t.homepage.taglist.jumpType = 'Jump Type'
t.homepage.taglist.remark = 'Remark'
t.homepage.taglist.contentQuantity = 'Content Quantity'
t.homepage.taglist.sort = 'Sort'
t.homepage.taglist.status = 'Status'
t.homepage.taglist.inProgress = 'In Progress'
t.homepage.taglist.closed = 'Closed'
t.homepage.taglist.off = 'Off'
t.homepage.taglist.itemOff = 'Unpublish'
t.homepage.taglist.itemOn = 'Publish'
t.homepage.taglist.cancelRelated = 'Cancel Related'
t.homepage.taglist.modifySort = 'Modify Sort'
t.homepage.taglist.content = 'Content'
t.homepage.taglist.engIcon = 'Icon(EN)'
t.homepage.taglist.thIcon = 'Icon(TH)'
t.homepage.taglist.jumpTypeForMONOPOLY = 'MONOPOLY'
t.homepage.taglist.jumpTypeForH5 = 'H5'
t.homepage.taglist.jumpTypeForURL = 'Url'
t.homepage.taglist.jumpTypeForBUYFREE = 'BUYFREE'
t.homepage.taglist.jumpTypeForBUYFREEDETAIL = 'BUYFREEDETAIL'
t.homepage.taglist.jumpTypeForMEMBER = 'MEMBER'
t.homepage.taglist.jumpTypeForWALLTE = 'WALLTE'
t.homepage.taglist.jumpTypeForLOGIN = 'LOGIN'
t.homepage.taglist.typeItemId = 'Type ID'
t.homepage.taglist.addContent= 'Add Content'
t.homepage.taglist.contentAdded = 'Content Added'
t.homepage.taglist.addProduct = 'Add Product'
t.homepage.taglist.addedProductItem = 'Added Product'
t.homepage.taglist.ableAddProductItem = 'Able Add Product'
t.homepage.taglist.addSpecialActivities = 'Add Special Activitiy'
t.homepage.taglist.addedSpecialActivity = 'Added Special Activity'
t.homepage.taglist.ableAddSpecialActivity = 'Able Add Special Activity'
t.homepage.taglist.addAdvertising = 'Add Advertising'
t.homepage.taglist.addHotSaleProduct = 'Add Hot-Sale Product'
t.homepage.taglist.add = 'Add'
t.homepage.taglist.remove = 'Remove'
t.homepage.taglist.Allremove = 'All remove'
t.homepage.activity = {}
t.homepage.activity.logo = 'LOGO'
t.homepage.activity.remark = 'Remark'
t.homepage.activity.title = 'Title'
t.homepage.activity.sku = 'SKU'
t.homepage.activity.stock = 'Stock'
t.homepage.activity.attribute = 'Attribute'
t.homepage.activity.attributeValue = 'Attribute value'
t.homepage.activity.backgroundPicture = 'Background Picture'
t.homepage.activity.tag = 'Tag'
t.homepage.activity.type = 'Type'
t.homepage.activity.sort = 'Sort'
t.homepage.activity.status = 'Status'
t.homepage.activity.advert = 'Advert'
t.homepage.activity.hotsales = 'Hotsales'
t.homepage.activity.product = 'Product Item'
t.homepage.activity.activity = 'Activity'
t.homepage.activity.activityPicture = 'Activity Picture'
t.homepage.activity.tagSort = 'Tag Sort'
t.homepage.activity.tagStatus = 'Tag Status'
t.homepage.activity.isHomePage = 'Is HomePage'
t.homepage.activity.homePageSort = 'HomePage Sort'
t.homepage.activity.statusEnable = 'Enable'
t.homepage.activity.statusDisable = 'Disable'
t.homepage.activity.bulkOperations = 'Bulk Operations, Selected'
t.homepage.hotsale = {}
t.homepage.hotsale.name = 'Name'
t.homepage.hotsale.engBackgroundPicture = 'Background Picture(EN)'
t.homepage.hotsale.thBackgroundPicture = 'Background Picture(TH)'
t.homepage.specialactivity = {}
t.homepage.specialactivity.logo = 'LOGO'
t.homepage.specialactivity.name = 'Name'
t.homepage.specialactivity.brandTitle = 'Brand Title'
t.homepage.specialactivity.title = 'Title' 
t.homepage.specialactivity.describe = 'Describe'
t.homepage.specialactivity.backgroundPicture = 'Background Picture'
t.homepage.specialactivity.coverPicture = 'Cover Picture'
t.homepage.specialactivity.tags = 'Tags' 
t.homepage.specialactivity.type =  'Type'
t.homepage.specialactivity.status = 'Status'
t.homepage.specialactivity.name = 'Name'
t.homepage.specialactivity.activity = 'Activity'
t.homepage.specialactivity.isHomePage = 'HomePage Show'
t.homepage.specialactivity.relatedTags = 'Related Tags'
t.homepage.specialactivity.Listtitle = 'List title'
t.homepage.specialactivity.Searchkey = 'Search keywords'
t.homepage.specialactivity.Catalog = 'Catalog'
t.homepage.specialactivity.alllistproduct = 'List of all products'
t.homepage.specialactivity.Catalogitemlist = 'Catalog item list'
t.homepage.specialactivity.Searchproductlist = 'Search product list'
t.homepage.specialactivity.Catalogproducts = 'Catalog products'
t.homepage.specialactivity.Cataloggoodsediting = 'Catalog goods editing'
t.homepage.specialactivity.takesapptip = '(The operation takes effect directly to the APP side)'

t.merchant = {}
t.merchant.name = 'Merchant Name'
t.merchant.intro = 'Merchant Intro'
t.merchant.mobile = 'Merchant mobile'
t.merchant.account = 'Merchant Account'
t.merchant.passwd = 'Merchant Password'
t.merchant.merchantId = 'Merchant'
t.merchant.accountList = 'Merchant Account List'
t.merchant.company = 'Merchant Company'
t.merchant.logo = 'Merchant Logo'
t.merchant.code = 'Merchant Code'
t.merchant.email = 'Merchant Email'
t.merchant.nameIsExistTips = 'The current merchant name already exists, please replace one to try'
t.merchant.nameIsNotExistTips = 'Current merchant name available'

t.merchant.label = {}
t.merchant.label.name = 'Supplier Name'
t.merchant.label.company = 'Company'
t.merchant.label.intro = 'Intro'
t.merchant.label.desc = 'Desc'
t.merchant.label.mobile = 'Mobile'
t.merchant.label.email = 'Email'


t.categorynew = {}
t.categorynew.addfirstClass="Create a new level 1 Classification"
t.categorynew.Multilingualname="Multilingual name"
t.categorynew.activation="Activation"
t.categorynew.firstName="First level classification name"
t.categorynew.firstsorting="First level sorting"
t.categorynew.newdirectory="New directory"
t.categorynew.Directoryname="Directory name"
t.categorynew.Relatedcommodities="Associated Goods"
t.categorynew.skuCount="Number of associated SKUs"

/**共用**/
t.public={}
t.public.set = 'Set'
t.public.edit = 'Edit'
t.public.add = 'Add'
t.public.delete = 'Delete'
t.public.details ='Details'
t.public.update = 'Update'
t.public.modify = 'Modify'
t.public.success = 'Success'
t.public.fail = 'Fail'
t.public.error = 'Error'
t.public.sort = 'Sort'
t.public.tips = 'Tips'
t.public.operation = 'Operation'
t.public.yes = 'Yes'
t.public.no = 'No'
t.public.submit = 'Submit'
t.public.reset = 'Reset'
t.public.confirm = 'Confirm'
t.public.cancel = 'Cancel'
t.public.back = 'Back'
t.public.title = 'Title'
t.public.content = 'Content'
t.public.picture = 'Picture'
t.public.search = 'Search'
t.public.query = 'Query'
t.public.output = 'Output'
t.public.icon = 'Icon'
t.public.selectedIcon = 'Selected Icon'
t.public.askDelete = '此操作将被永久删除。是否继续?'
t.public.chinese = 'Chinese'
t.public.english = 'English'
t.public.thai = 'Thai'
t.public.createTime = 'Create Time'
t.public.finishTime = 'Finish Time'
t.public.status = 'Status'
t.public.valid = 'Valid'
t.public.invalid = 'Invalid'
t.public.iSee = 'I See'
t.public.close = 'Close'
t.public.remark = 'Remark'

    t.public.loginAccount = 'Login Account',
    t.public.password = 'Password',
    t.public.repeatPassword = 'Repeat Password',
    t.public.userRole = 'User Role',
    t.public.employeeName = 'Employee Name',
    t.public.employeeId = 'EmployeeId',
    t.public.AffiliatedDepartment = 'Affiliated Department',
    t.public.employeeMobile = 'Employee Mobile',
    t.public.employeeEmail = 'Employee Email',
    



t.public.value = 'Value'
t.public.baseInformation = 'Base Information'
t.public.all = 'All'
t.public.name = 'Name'
t.public.numberSort = 'The higher the number, the higher the ranking.'
t.public.advert = 'Advert'
t.public.profile = 'Profile'
t.public.backgroundPicture = 'Background Picture'
t.public.Initials = 'Initials'
t.public.price = 'Price'
t.public.resetSearchKeyword = 'Reset Search Keyword'
t.public.product = 'Single product'
t.public.onShelves = 'On shelves'
t.public.offShelf = 'Off shelf'
t.public.prohibit = 'Prohibit'
t.public.enable = 'Enable'
t.public.filter = 'filter'
t.public.skuProportion = 'Effective SKUs / total'
t.public.minimumValue = 'minimum value'
t.public.maximum = 'Maximum'
t.public.Commoditymanag = 'Commodity management'
t.public.Activitymanagement = 'Activity management'
t.public.Pleasename = 'Please enter a name'
t.public.commodity = 'Commodity'

t.product.itemAdded = 'Item added'
t.product.canAddGoods = 'Can Add Goods'

t.commissonAct={}
t.commissonAct.skucode="Commodity SKU"
t.commissonAct.processing="Processing"
t.commissonAct.expired="Expired"
t.commissonAct.image="Image"
t.commissonAct.Originalprice="Original price"
t.commissonAct.Disprice="Discounted price"
t.commissonAct.Afterprice="After voucher price"
t.commissonAct.commission="Commission"
t.commissonAct.Validperiod="Valid period"
t.commissonAct.Couponrules="Coupon rules"
t.commissonAct.getedCount="Quantity received"
t.commissonAct.usedCount="Quantity used"
t.commissonAct.Selectproduct="Select product"
t.commissonAct.Clickcollapse="Click to collapse"
t.commissonAct.Clickselect="Click to select"
t.commissonAct.Amount="Amount"
t.commissonAct.percentage="Percentage"
t.commissonAct.timesLimit="Limit the number of times/person:"
t.commissonAct.totalCount="Total:"
t.commissonAct.Effectivedate="Effective date:"
t.commissonAct.selectgoods="Please select a product"
t.commissonAct.Setinvalid="Set activity invalid"
t.commissonAct.pieces="Piece"
t.commissonAct.piecePerson="Piece/Person"

t.liveBroadcast={}
t.liveBroadcast.Indisplay="Showing"
t.liveBroadcast.begininaminute="About to start"
t.liveBroadcast.Live="Live"
t.liveBroadcast.Replay="Replay"
t.liveBroadcast.Sortreplacement="Sort replacement"
t.liveBroadcast.Changelive="Change live"
t.liveBroadcast.searchKey="Enter the live room ID/live name/shop name"
t.liveBroadcast.Allstatus="All status"
t.liveBroadcast.Livestarttime="Live broadcast start time"
t.liveBroadcast.Settime="Set time"
t.liveBroadcast.seedetails="See Details"
t.liveBroadcast.Entertheliveroom="Enter the live room"
t.liveBroadcast.Confirmselection="Confirm selection"
t.liveBroadcast.Liveroomdetails="Live room details"
t.liveBroadcast.Savechanges="Save changes"
t.liveBroadcast.Oneself="Oneself"
t.liveBroadcast.Allusers="All users"
t.liveBroadcast.Horizontalscreen="Horizontal screen"
t.liveBroadcast.Portrait="Portrait"
t.liveBroadcast.Platformcover="Shop cover"
t.liveBroadcast.Platformname="Shop name"
t.liveBroadcast.Hidden="Hidden"
t.liveBroadcast.Associatedanchor="Associated anchor"
t.liveBroadcast.Audiencesize="Audience size"
t.liveBroadcast.MessageBoard="Message Board"
t.liveBroadcast.Data="Data"
t.liveBroadcast.Livelist="Live list"

// from merchant begin

t.product.label = {}
t.product.label.editPrice = 'Price & Stock'
t.product.label.priceAndStock = 'Price And Stock'
// t.product.label.priceLevel10 = 'Price For 普通经销商无账期'
// t.product.label.priceLevel11 = 'Price For 普通经销商有账期'
// t.product.label.priceLevel20 = 'Price For vip经销商无账期'
// t.product.label.priceLevel21 = 'Price For vip经销商有账期'
// t.product.label.priceLevel30 = 'Price For 普通企业客户无账期'
// t.product.label.priceLevel40 = 'Price For vip企业客户无账期'
t.product.label.priceLevel0 = 'Price'
t.product.label.priceLevel2 = 'Price For VIP Distributor'
t.product.label.priceLevel1 = 'Price For Distributor&VIP Corporate'
t.product.label.priceLevel3 = 'Price For Corporate'

t.product.label.priceLevel10 = 'Distributor'
t.product.label.priceLevel11 = 'Distributor (Credit terms)'
t.product.label.priceLevel20 = 'VIP Distributor'
t.product.label.priceLevel21 = 'VIP Distributor (Credit terms)'
t.product.label.priceLevel30 = 'Corporate'
t.product.label.priceLevel40 = 'VIP Corporate'

// t.product.label.originalprice = 'Retail Price'
t.product.label.originalprice = 'SRP'
t.product.label.priceCost = 'Cost Price'

t.product.label.total = 'Stock'
t.product.label.stock = 'Stock update'
t.product.label.overseasTotal = 'Overseas stock'
t.product.label.overseasStock = 'Overseas update'
t.product.label.minCount = 'Min Order Quantity'
t.product.itemAdded = 'Item added'
t.product.canAddGoods = 'Can Add Goods'

t.product.label.name = 'name'
t.product.label.multiLangSetting = 'multiLangSetting'
t.product.label.category = 'category'
t.product.label.catalog = 'catalog'
t.product.label.merchantCatalog = 'merchantCatalog'
t.product.label.jumpToCatalogManage = 'jumpToCatalogManage'
t.product.label.manufacturer = 'manufacturer'
t.product.label.selectSpecially = 'selectSpecially'
t.product.label.supplier = 'supplier'
t.product.label.keyword = 'keyword'
t.product.label.longDescription = 'Long Description'
t.product.label.clickToAddSku = 'clickToAddSku+'
t.product.label.clickToAddSkuOption = 'clickToAddOption+'
t.product.label.skuName = 'Sku name'
t.product.label.propertyName = 'Option name'
t.product.label.skuValue = 'Option value'
t.product.label.status = 'Goods status'
t.product.label.clickToAddItem = 'Click To Add Goods+'
t.product.item.name = 'Goods Name'
t.product.hint = {}
t.product.hint.skuPropertyName = 'Option Name'
t.product.hint.skuValue = 'Option Value'

t.product.ruleMessage = {}
t.product.ruleMessage.price = 'Price cannot be empty'
t.product.ruleMessage.originalPrice = 'SRP Price cannot be empty'
t.product.ruleMessage.total = 'Stock cannot be empty'
t.product.ruleMessage.code = 'Code cannot be empty'
t.product.ruleMessage.barCode = 'Barcode cannot be empty'



t.member.label = {}
t.member.label.agree = 'Agree'

t.order.confirmContent = {}
t.order.confirmContent.level10 = 'Dear customer, \n  According to the order submitted by you, we confirm the estimated delivery date according to the estimated delivery and logistics time of the goods:\n \n                                                                             #ARRIVEDATE# \n \n  In view of your good credit, we will You pay in advance, please prepare cash or credit card payment at the time of delivery. '
t.order.confirmContent.level11 = t.order.confirmContent.level10
t.order.confirmContent.level1 = t.order.confirmContent.level11
t.order.confirmContent.level20 = 'Dear customer, \n  According to the order submitted by you, we confirm the estimated delivery date according to the estimated delivery and logistics time of the goods:\n \n                                                                             #ARRIVEDATE# \n \n  In view of your good credit, please go to #PAYDAYS# days Within the payment, the remaining payment will be made up after the goods are delivered, otherwise the order will be cancelled automatically. '
t.order.confirmContent.level21 = t.order.confirmContent.level20
t.order.confirmContent.level30 = 'Dear customer, \n  According to the order submitted by you, we confirm the estimated delivery date according to the estimated delivery and logistics time of the goods:\n \n                                                                             #ARRIVEDATE# \n \n  In view of your good credit, please go to #PAYDAYS# days Within the prepayment ฿ #AMOUNT#, the remaining payment will be made up after the goods are delivered, otherwise the order will be cancelled automatically. '
t.order.confirmContent.level31 = t.order.confirmContent.level30

t.order.unit = {}
t.order.unit.productType = 'Kinds'
t.order.unit.productCount = 'Piece'

t.order.search = {}
t.order.search.inputHint = 'Please Input'
t.order.search.selectHint = 'Please Choose'

t.order.step = {}
t.order.step.createOrder = 'Submit Order'
t.order.step.confirmOrder = 'Confirm'
t.order.step.confirmPaidFront = 'Advance Payment'
t.order.step.confirmPaidRest = 'Final Payment'
t.order.step.confirmPaid = 'To Pay'
t.order.step.delivered = 'In Transit'
t.order.step.finished = 'Completed'

t.order.COMMITED = 'Submitted'
t.order.WAP = 'To Be Prepaid'
t.order.WFP = 'Pending Payment'


t.member.label.audit = 'User Verify'
t.member.label.username = 'User Name'
t.member.label.mobile = 'Phone Number'
t.member.label.phoneNo = 'TeL.'
t.member.label.companyName = 'Company Name'
t.member.label.userLevel = 'User Level'
t.member.label.createTime = t.user.createDate
t.member.label.status = t.user.status
t.member.label.operation = t.user.status
t.member.value = {}
t.member.value.statusY = 'Normal'
t.member.value.statusN = 'Terminated'
t.member.value.statusU = 'Unset'
t.member.label.showDetail = 'Check Details'
t.member.label.createUser = 'Create User'
t.member.label.userDetail = 'User Details'


t.member.label.baseInfo = 'User basic information'
t.member.label.platformId = 'Platform ID'
t.member.label.companyName = 'Company name'
t.member.label.companyFax = 'Company tax number'
t.member.label.contractName = 'Contact name'



t.member.label.mobile = 'Contact phone number'
t.member.label.phoneNo = 'Fixed phone'
t.member.label.email = 'Mailbox'
t.member.label.platformInfo = 'User platform information'
t.member.label.username = 'User account'
t.member.label.password = 'User password'
t.member.label.level = 'User level'
t.member.label.otherInfo = 'Other information'
t.member.label.totalAmount = 'Total transaction amount'
t.member.label.orderCount = 'Total number of orders placed'
t.member.label.availOrderCount = 'Number of valid orders'
t.member.label.lastOrderTime = 'Last transaction time'
t.member.label.lastOrderAmount = 'Last order amount (?)'
t.member.label.baseInfo = 'User basic information'
t.member.label.platformId = 'Platform ID'
t.member.label.companyName = 'Company name'
t.member.label.companyFax = 'Company tax number'
t.member.label.contractName = 'Contact name'
t.member.label.mobile = 'Contact phone number'
t.member.label.phoneNo = 'Landline'
t.member.label.email = 'Mailbox'
t.member.label.platformInfo = 'User platform information'
t.member.label.username = 'User account'
t.member.label.password = 'User password'
t.member.label.level = 'User level'
t.member.label.otherInfo = 'Other information'
t.member.label.totalAmount = 'Total transaction amount'
t.member.label.orderCount = 'Total number of orders placed'
t.member.label.companyTaxno = 'Tax Number'

t.product.label.hint = 'Description'
t.product.label.productSpecification = 'Specification'
t.product.label.productAfterSale = 'After Sale'
t.product.label.productStandardQuestion = 'Standard Question'
t.product.label.copyItem = 'Copy'

t.product.label.all = 'All'
t.product.label.waitForAuditing = 'Auditing'
t.product.label.onShelf = 'On Shelf'
t.product.label.offShelf = 'Off Shelf'
t.product.label.deleted = 'Deleted'
t.product.label.warningList = 'Warning List'

t.product.label.Sku = 'SKU'
t.product.label.SkuName = 'SKU Desc'
t.product.label.price = 'Price'
t.product.label.saled = 'Saled Count'
t.product.label.publish = 'Status'
t.product.label.operation = 'Operation'
t.product.label.productId = 'ID'
t.product.label.merchantId = 'Supplier'
t.product.search = {}
t.product.search.selectHint = 'Select'
t.product.search.inputHint = 'Input'
t.product.label.productName = 'Product Name'
t.product.label.minQuantity = 'Minimum order quantity'
t.order.payType = 'Payment Method'

t.product.stockThailand='Stock in Thailand'
t.product.stockoverseas='Stock in overseas'
t.public.Recommendedproducts = 'Recommended products'
t.product.setuprecproducts = 'Set up recommended products'
t.merchant.certificatePicture = 'Certificate Picture'
t.product.label.resetKeyword = 'Refresh Keyword'
t.product.hint.cover = 'Replace'

t.category = {}
t.category.commodityCategory = 'Category'

t.social={}
t.social.Customerinfor='Customer information'
t.social.Ordersource='Order source'
t.social.UserID='User ID'
t.social.addressee='Addressee'
t.social.province='Province'
t.social.PostalCode='Postal Code'
t.social.area='Area'
t.social.Detailedaddress='Detailed address'
t.social.Customermessage='Customer message'
t.social.Paymentmethod='Payment method'
t.social.Productinformation='Product information'
t.social.Pleasename='Please enter the product name'
t.social.Optionname='Option name'
t.social.price='Price'
t.social.Purchasequantity='Purchase quantity'
t.social.Selectquantity='Select quantity'
t.social.Confirmadd='Confirm add'
t.social.Confirmordercreation='Confirm order creation'
t.social.Productdescription='Product description'
t.social.Iteminformation='Item information'
t.social.Carouselmap='Carousel map'
t.social.Availablestock='Available stock'
t.social.Floatingstock='Floating stock'
t.social.Customsellingprice='Custom selling price'
t.social.Discountprice='Discount price'
t.social.Flashsaleprice='Flash sale price'
t.social.CreateOrder='+Create Order'

t.order.label = {}
t.order.label.all = 'All'
t.order.label.waitForAuditing = 'Pending Review'
t.order.label.waitForPay = 'To Be Paid'
t.order.label.waitForDelivery = 'To Be Delivered'
t.order.label.waitForReceive = 'To Be Received'
t.order.label.canceled = 'Cancel'
t.order.label.finished = 'Completed'
t.order.label.orderId = 'Order Number'
t.order.label.username = 'User Name'
t.order.label.productCode = ''
t.order.label.productKeywords = 'Keyword'
t.order.label.orderCode = 'Order Number'
t.order.label.createTime = 'Order Submission Time'
t.order.label.confirmTime = 'Order Confirmation Time'
t.order.label.finishTime = 'Order Completion Time'
t.order.label.productInfo = 'Product Information'
t.order.label.productName = 'Product Name'
t.order.label.productProperty = 'Product Properties'
t.order.label.orderInfo = 'Order Information'
t.order.label.logisticsInfo = 'Logistics Information'
t.order.label.orderStatus = 'Order Status'
t.order.label.contactName = 'Receiver'
t.order.label.address = 'Address'
t.order.label.mobile = 'Cell Phone'
t.order.label.contractNo = 'TeL'
t.order.label.receiveRemark = 'Message'
t.order.label.companyName = 'Company'
t.order.label.historyOrder = 'Historical Order'

t.order.label.operation = 'Operation'
t.order.label.productType = 'Types of Goods'
t.order.label.count = 'Total Quantity'
t.order.label.clickToShowPrefix = 'Click to check(Totally:'
t.order.label.clickToHidePrefix = 'Click to hide(Totally:'
t.order.label.clickToShowSuffix = ')'
t.order.label.clickToHideSuffix = ')'
t.order.label.copy = 'Copy'
t.order.label.ViewOrderDetail = 'View Order Details'
t.order.label.confirmArriveDate = 'Send the Delivery Date'
t.order.label.confirmPaid = 'Confirm the Payment'
t.order.label.confirmPaidFront = 'Confirm Prepayment'
t.order.amountFlag = '฿'
t.order.label.productName = 'Product Name'

t.order.label.totalAmountOfCommodity = 'Total Amount of Commodity'
t.order.label.totalFreight = 'Total Freight'
t.order.label.discount = 'Discount'
t.order.label.total = 'Total'
export default t
